/** 页面信息 */
export interface PageData {
  /** 宽度 */
  w: number

  /** 高度 */
  h: number

  /** 页码，从 0 开始 */
  p: number

  /** 页面图片 */
  src?: string

  /** 页面 HTML */
  html?: string

  // eslint-disable-next-line
  [key: string]: any
}

/** 合同页面统计 */
export interface PageSum {
  /** 最小宽度 */
  minWidth: number

  /** 最小高度 */
  minHeight: number

  /** 最大宽度 */
  maxWidth: number

  /** 最大高度 */
  maxHeight: number
}

/** 合同文档基础信息 */
export interface DocData {
  /** 文档 id */
  id: string

  /** 文档名 */
  name: string

  /** 页面数据 */
  pages: PageData[]

  // eslint-disable-next-line
  [key: string]: any
}

/** 应用页面 */
export enum ApplyPage {
  /** 奇数页 */
  ODD = 'ODD',

  /** 偶数页 */
  EVEN = 'EVEN'
}
